"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineWrapper = exports.StepIconWrapper = exports.StepContainer = void 0;
const native_1 = __importStar(require("styled-components/native"));
exports.StepContainer = native_1.default.View `
  ${({ isLastStep }) => !isLastStep &&
    native_1.css `
      flex: 1;
    `};
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
exports.StepIconWrapper = native_1.default.View `
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
exports.LineWrapper = native_1.default.View `
  flex: 1;
  margin: 0 6px;
`;
